import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

import { Modal } from "react-bootstrap";
import SelectForForm from "../../../GeneralComponents/componentsForForm/selectForForm/SelectForForm";
import SelectWithSearch from "../../../GeneralComponents/componentsForForm/selectWithSearch/SelectWithSearch";
import InputForForm from "../../../GeneralComponents/componentsForForm/inputForForm/InputForForm";

import {
  addDataBasesBuildings,
  archiveBasesBuildings,
  editDataBasesBuildings,
} from "../../../../redux/baseBuildingReducer/actionsBaseBuilding";

import {
  optionsButton,
  getInputsPropsForModalWindow,
  setInputsPropsForModalWindow,
} from "./constantsForModalWindowForBaseseBuilding";

import { SET_ERROR_MESSAGE_BASES } from "../../../../redux/types";

import styles from "./modalWindowForBasesBuilding.module.css";

function ModalWindowForBasesBuilding({
  setShow,
  show,
  type,
  buildingId,
  setShowConfirmationModal,
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
  } = useForm();
  const [dataForm, setDataForm] = useState({});
  const [inputOptions, setInputOptions] = useState({});

  const dataFromStateBases = useSelector((state) => {
    const { basesBuildingReducer } = state;
    return basesBuildingReducer;
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const archiveAccess = useChapterActionIdMatch(
    sortedMenuNames?.BASES_BUIDING?.archiving?.chapterActionId,
  );

  const optionsOwnerOblast = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allOblast
      .map((el) => {
        if (el.id !== 5) {
          return { ...el, key: "ownerOblast" };
        }
      })
      .filter((item) => item !== undefined);
  });

  const resolveSubmit = async (data) => {
    if (type === "add") {
      dispatch(addDataBasesBuildings(data));
    }
    if (type === "edit") {
      dispatch(editDataBasesBuildings({ ...data, parkId: buildingId }));
    }
    setShow(false);
    setShowConfirmationModal(true);
  };

  const archiveButton = () => {
    dispatch(archiveBasesBuildings(buildingId));
  };

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setShow(false);
  };

  async function changeParamsForOptions(typeField, props) {
    if (type !== "view") {
      switch (typeField) {
        case "ownerOblast": {
          setValue("ownerRayon", undefined);
          setValue("section", undefined);
          break;
        }
        case "ownerRayon": {
          setValue("section", undefined);
          break;
        }
        default:
          break;
      }
    }
    await setInputsPropsForModalWindow(typeField, props, type);
    setInputOptions({ ...getInputsPropsForModalWindow() });
  }

  async function setInitParamsForOptions() {
    await setInputsPropsForModalWindow(
      "firstInit",
      {
        ownerOblast: optionsOwnerOblast,
      },
      type,
    );
    if (
      dataFromStateBases.data.content.length &&
      (type === "edit" || type === "view")
    ) {
      const data = dataFromStateBases.data.content.find(
        (el) => el.parkId == buildingId,
      );
      setDataForm(data);
    }
    setInputOptions(getInputsPropsForModalWindow());
  }

  useEffect(() => {
    setInitParamsForOptions().then();
  }, []);

  useEffect(() => {
    const asyncWatch = async (value, { name }) => {
      if (value[name]) {
        await changeParamsForOptions(name, value[name]);
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_ERROR_MESSAGE_BASES,
        data: "",
      });
    };
  }, []);

  return (
    <Modal show={show} onHide={handleClose} size="xl" fullscreen="lg-down">
      <Modal.Header closeButton className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>
          {optionsButton[type]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <form
          className={styles.container}
          onSubmit={handleSubmit(resolveSubmit)}
        >
          {Object.values(inputOptions).map((option) => (
            <div key={option.key} className={styles[`box-${option.key}`]}>
              {(() => {
                switch (option.type) {
                  case "select":
                    return (
                      <SelectForForm
                        mode={type}
                        register={register}
                        inputProps={option}
                        errors={errors}
                        setValue={setValue}
                        dataForm={dataForm}
                      />
                    );
                  case "selectWithSearch":
                    return (
                      <SelectWithSearch
                        mode={type}
                        inputProps={option}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        dataForm={dataForm}
                      />
                    );
                  default:
                    return (
                      <InputForForm
                        mode={type}
                        register={register}
                        inputProps={option}
                        errors={errors}
                        setValue={setValue}
                        setError={setError}
                        clearErrors={clearErrors}
                        dataForm={dataForm}
                      />
                    );
                }
              })()}
            </div>
          ))}
          {(type === "add" || type === "edit") && (
            <div className={styles["box-buttons"]}>
              <button className={styles["save-btn"]}>Сохранить</button>
              {type === "edit" && archiveAccess && (
                <button
                  type={"button"}
                  onClick={archiveButton}
                  className={styles["archive-btn"]}
                >
                  В архив
                </button>
              )}
            </div>
          )}
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default ModalWindowForBasesBuilding;
